import isEqual from "lodash.isequal";
import {
  MDBCheckbox,
  MDBCol,
  MDBInput,
  MDBRow,
  MDBSelect,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";

function CampaignTypes({
  campaignMiscInfo,
  savedUseCases,
  SavedConsent,
  allLocations = [],
  billingGroupList = [],
  status,
}) {
  const {
    register,
    watch,
    setValue,
    control,
    formState: { errors },
    getValues,
    clearErrors,
  } = useFormContext();

  const {
    fields: useCaseFields,
    append: appendUseCase,
    remove: removeUseCase,
  } = useFieldArray({
    control,
    name: "campaign_details.camp_desc.smpl_msgs",
  });

  // OLD: Array-based consent field array (commented out — consent_msg is now a single string)
  // const {
  //   fields: consentFields,
  //   append: appendConsent,
  //   remove: removeConsent,
  // } = useFieldArray({
  //   control,
  //   name: "campaign_details.camp_desc.consent_msg",
  // });


 const isPPLogin = (JSON.parse(sessionStorage.getItem("admin_session"))?.loggedInFromPP === true) ?? false;
//  const isPPLogin = false;

 // Use case specifically is editable only while the campaign is still Pending (no login bypass) —
 // once it's created (any other status), it's locked for everyone. This is additional to, and narrower
 // than, the section-wide DCA-Complete lock below (which still governs every other field in this form).
 const isPending = !status || status === "Pending";

  const [selectedUseCases, setSelectedUseCases] = useState([]);
  // OLD: const [selectedConsents, setSelectedConsents] = useState([]);
  const [justShook, setJustShook] = useState(null);

  const sessioncompanyName =
    sessionStorage.getItem("admin_session") &&
      JSON.parse(sessionStorage.getItem("admin_session"))?.companyName
      ? JSON.parse(sessionStorage.getItem("admin_session")).companyName
      : "";

  // const modifyCompanyName = sessionStorage.getItem("modify_company_name");

  const companyname = sessioncompanyName;

  const usecases = campaignMiscInfo?.sub_usecases ?? [];
  // OLD: const consentMessageList = campaignMiscInfo?.consentMsg ?? [];
  const staticTexts = campaignMiscInfo?.staticTexts ?? {};

  const useCaseOptions = usecases.map((cases) => ({
    text: cases.usecase,
    value: cases.usecase_id,
  }));

  // OLD: const consentOptions = consentMessageList.map((item) => ({ text: item.msg_type, value: item.id }));

  // Watch for changes to sync with form state
  const watchedUseCases = watch("campaign_details.usecases.subcase");

  // Initialize default 2 sample messages if none exist
  useEffect(() => {
    const currentMessages = watch("campaign_details.camp_desc.smpl_msgs") || [];
    if (currentMessages.length === 0) {
      setValue("campaign_details.camp_desc.smpl_msgs", [
        { id: 1, msg_txt: "", isNew: false },
        { id: 2, msg_txt: "", isNew: false }
      ], { shouldDirty: false });
    } else if (currentMessages.length < 2) {
      // Ensure at least 2 messages
      const needed = 2 - currentMessages.length;
      for (let i = 0; i < needed; i++) {
        appendUseCase({ id: currentMessages.length + i + 1, msg_txt: "", isNew: false }, { shouldFocus: false });
      }
    }
  }, []);

  // Handle Add Sample Message
  const handleAddSampleMessage = () => {
    if (useCaseFields.length >= 5) {
      setJustShook("sample-messages");
      setTimeout(() => setJustShook(null), 500);
      return;
    }

    const newId = useCaseFields.length + 1;
    appendUseCase({ id: newId, msg_txt: "", isNew: true }, { shouldFocus: false });
  };

  // FIXED: Handle Remove Sample Message with reindexing - PRESERVE isNew flag
  const handleRemoveSampleMessage = (index) => {
    if (useCaseFields.length <= 2) {
      return;
    }

    removeUseCase(index);

    // Reindex remaining messages - PRESERVE isNew flag
    setTimeout(() => {
      const currentMessages = watch("campaign_details.camp_desc.smpl_msgs") || [];
      const reindexedMessages = currentMessages.map((msg, idx) => ({
        id: idx + 1,
        msg_txt: msg.msg_txt || "",
        isNew: msg.isNew || false  // FIXED: Preserve the isNew flag
      }));
      setValue("campaign_details.camp_desc.smpl_msgs", reindexedMessages, {
        shouldDirty: true,
      });
    }, 0);
  };

  // Initialize selected values from form
  useEffect(() => {
    if (watchedUseCases && Array.isArray(watchedUseCases)) {
      setSelectedUseCases(watchedUseCases);
    }
  }, [watchedUseCases]);

  // OLD: Array-based consent sync (commented out — consent_msg is now a single string)
  // useEffect(() => {
  //   if (watchedConsents && Array.isArray(watchedConsents)) {
  //     const cosentList = watchedConsents?.map((val) => parseInt(val.consent_type));
  //     setSelectedConsents(cosentList);
  //   }
  // }, [watchedConsents]);

  // Handle use case selection changes
  const handleUseCaseChange = (selectedValues) => {
    const currentValues = selectedValues || [];
    const previousValues = selectedUseCases;

    // Find newly added use cases
    const addedUseCases = currentValues.filter(
      (val) => !previousValues.includes(parseInt(val))
    );
    // Find removed use cases
    const removedUseCases = previousValues.filter(
      (val) => !currentValues.includes(val)
    );

    // NOTE: No longer adding/removing sample messages based on use cases
    // Sample messages are now independent

    setSelectedUseCases(currentValues.map((v) => parseInt(v)));
    setValue(
      "campaign_details.usecases.subcase",
      currentValues.map((v) => parseInt(v)),
      { shouldDirty: true, shouldValidate: true }
    );
  };

  // OLD: Array-based consent change handler (commented out — consent_msg is now a single string)
  // const handleConsentChange = (selectedValues) => { ... };

  const handleUseCaseOnChange = (selectedOptions) => {
    let nextValues = [];
    if (Array.isArray(selectedOptions)) {
      nextValues = selectedOptions
        .map((option) => option.value)
        .filter((v) => v !== undefined && v !== null && v !== "");
    }
    if (nextValues.length > 5) return;
    const exist = watch("campaign_details.usecases.subcase");
    if (
      exist &&
      exist.length > 0 &&
      isEqual([...exist].sort(), [...nextValues].sort())
    )
      return;

    handleUseCaseChange(nextValues);
  };

    const [websitecollectModal, setwebsitecollectModal] = useState(false);
  
    const toggleOpen = () => setwebsitecollectModal(!websitecollectModal);
  

  return (
    <>
      <div
        {...(status === "DCA Complete" && !isPPLogin
          ? {
              title: `This campaign is ${status}. Only Location, Billing Group, and Select Phone Numbers can be edited — please contact the LNP Team for other changes.`,
              className: "disabled-form cursor-notAllowed",
              onClick: (e) => {
                if (e.target.closest(".always-editable")) return;
                e.preventDefault();
                e.stopPropagation();
              },
            }
          : {})}
      >
        <div className="add-numbermain">
          <div>
            <div className="tel-numbers fw-500">Campaign Name</div>
          </div>
          <div className="d-flex w-40">
            <MDBInput
              maxLength={50}
              {...register("campaign_details.campaign_name", {
                // required: "Campaign Name is required",
                minLength: {
                  value: 2,
                  message: "Campaign Name must be at least 2 characters",
                },
                maxLength: {
                  value: 50,
                  message: "Campaign Name cannot exceed 50 characters",
                },
                // validate: (value) =>
                //   value.trim() !== "" || "Campaign Name is required",
              })} />
            {errors?.campaign_details?.campaign_name && (
              <div className="text-danger mt-1">
                {errors.campaign_details.campaign_name.message}
              </div>
            )}
          </div>
        </div>

        <div className="add-numbermain always-editable" title="">
          <div className="tel-numbers">
            Location <span className="text-danger">*</span>
          </div>

          <div className="sms-compliance-form-field w-40">
            <Controller
              name="campaign_details.location_id"
              control={control}
              rules={{
                validate: (value) =>
                  Number(value) > 0 || "Please select location",
              }}
              render={({ field }) => (
                <select
                  className="form-select"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(Number(e.target.value))}
                >
                  <option value="">Select Location</option>

                  {allLocations.map((loc) => (
                    <option key={loc.loc_id} value={loc.loc_id}>
                      {loc.loc_name}
                    </option>
                  ))}
                </select>
              )}
            />

            {errors?.campaign_details?.location_id && (
              <div className="text-danger sms-compliance-form-error">
                {errors.campaign_details.location_id.message}
              </div>
            )}
          </div>
          </div>

        <div className="add-numbermain always-editable" title="">
         <div className="tel-numbers">
            Billing Group <span className="text-danger">*</span>
          </div>

          <div className="sms-compliance-form-field w-40">
            <Controller
              name="campaign_details.billing_group_id"
              control={control}
              rules={{
                validate: (value) =>
                  billingGroupList.some(
                    (b) => b.groupid === Number(value)
                  ) || "Billing group is required",
              }}
              render={({ field }) => (
                <select
                  className="form-select"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(Number(e.target.value))}
                >
                  <option value="">Select Billing Group</option>

                  {billingGroupList.map((bgrp) => (
                    <option key={bgrp.groupid} value={bgrp.groupid}>
                      {bgrp.groupname}
                    </option>
                  ))}
                </select>
              )}
            />

            {errors?.campaign_details?.billing_group_id && (
              <div className="text-danger sms-compliance-form-error">
                {errors.campaign_details.billing_group_id.message}
              </div>
            )}
          </div>
        </div>

        <div className={`add-numbermain${!isPending ? " disabled-form cursor-notAllowed" : ""}`} title={!isPending ? "This field cannot be edited once the campaign is submitted ." : ""}>
           <div className="tel-numbers">
            Estimated Monthly Message Volume{" "}
            <span className="text-danger">*</span>
          </div>

          <div className="sms-compliance-form-field w-40">
            <select
              className="form-select"
              disabled={!isPending}
              {...register("campaign_details.camp_desc.cmp_usage", {
                valueAsNumber: true,
                required: "Estimated Monthly Message Volume is required",
              })}
            >
              <option value="">Select Usage Type</option>
              <option value={1}>Low Volume Campaign</option>
              <option value={2}>Standard Campaign</option>
            </select>

            {errors?.campaign_details?.camp_desc?.cmp_usage && (
              <div className="text-danger sms-compliance-form-error">
                {errors.campaign_details.camp_desc.cmp_usage.message}
              </div>
            )}
          </div>
        </div>

        <div className={`add-numbermain${!isPending ? " disabled-form cursor-notAllowed" : ""}`} title={!isPending ? "This field cannot be edited once the campaign is submitted ." : ""}>
          <div>
    <div className="tel-numbers fw-500">
      Use case <span className="text-danger">*</span>
    </div>

    <span className="sms-compliance-form-helper text-secondary">
      {`Select a minimum of ${
        Number.isFinite(
          watch("campaign_details.camp_desc.cmp_usage")
        )
          ? watch("campaign_details.camp_desc.cmp_usage")
          : 1
      } and a maximum of 5`}
    </span>
  </div>

  <div className="sms-compliance-form-field w-40">
    <Controller
      name="campaign_details.usecases.subcase"
      control={control}
      rules={{
        validate: (value) => {
          const usage = watch(
            "campaign_details.camp_desc.cmp_usage"
          );

          const minimum = usage
            ? parseInt(usage)
            : 1;

          if (!value || value.length < minimum) {
            return `At least ${
              minimum === 1 ? "one" : "two"
            } use cases required`;
          }

          if (value.length > 5) {
            return "Maximum 5 use cases allowed";
          }

          return true;
        },
      }}
      render={({ field }) => (
        <MDBSelect
          multiple
          className="mdbselect-force-disabled"
          disabled={!isPending}
          data={useCaseOptions.map((item) => ({
            ...item,
             disabled:
              !isPending ||
              (selectedUseCases.length >= 5 &&
              !selectedUseCases.includes(parseInt(item.value))),
            className:
              selectedUseCases.length >= 5
                ? "danger"
                : "",
          }))}
          placeholder="Select use case"
          value={selectedUseCases}
          selectAll={false}
          onChange={handleUseCaseOnChange}
        />
      )}
    />

    {errors?.campaign_details?.usecases?.subcase && (
      <div className="text-danger sms-compliance-form-error">
        {errors.campaign_details.usecases.subcase.message}
      </div>
    )}
  </div>
</div>

        <div className="add-numbermain">
          <div className="tel-numbers">Embedded Link</div>
          <div className="w-30">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                {...register("campaign_details.embed_link")}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">Embedded Phone Number</div>
          <div className="w-30">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                {...register("campaign_details.embed_phno")}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">Age-Gated Content</div>
          <div className="w-30">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                {...register("campaign_details.age_content")}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        {/* NEW: Independent Sample Messages Section */}
        <div className="add-numbermain align-items-start noHoverBg">
          <div className="d-flex flex-column">
            <div className="tel-numbers fw-500">Sample Messages</div>
            <span className="phrecording text-secondary">
              Minimum 2, Maximum 5 messages
            </span>
          </div>
          {useCaseFields.length < 5 && (
            <MDBBtn
              size="sm"
              className={`mb-3 ${justShook === "sample-messages" ? "shake" : ""}`}
              type="button"
              onClick={handleAddSampleMessage}
            >
              <MDBIcon fas icon="plus" /> Add
            </MDBBtn>
          )}
        </div>

        {/* Sample Messages */}
        {useCaseFields.map((field, index) => {
          const path = `campaign_details.camp_desc.smpl_msgs.${index}.msg_txt`;
          const value = watch(path) || "";
          const length = value.trim().length;
          // FIXED: Check both field.isNew and the actual value from watch
          const currentMessage = watch(`campaign_details.camp_desc.smpl_msgs.${index}`);
          const showRemove = currentMessage?.isNew === true;

          return (
            <div key={field.id} className="camp-form p-0">
              <div className="p-3 rounded-3 mt-2 bg-opacity-10 add-numbermain w-100">
                <div className="message-section show w-100">
                  <div className="message-header d-flex justify-content-between align-items-center">
                    <label className="tel-numbers fw-500">
                      Sample Message {index + 1} <span className="text-danger">*</span> (Minimum 20 characters)
                    </label>
                    {showRemove && (
                      <MDBBtn
                        color="danger"
                        outline
                        size="sm"
                        type="button"
                        onClick={() => handleRemoveSampleMessage(index)}
                        className="d-flex align-items-center gap-1"
                      >
                        <MDBIcon fas icon="times" />
                        remove
                      </MDBBtn>
                    )}
                  </div>

                  <Controller
                    name={path}
                    control={control}
                    rules={{
                      required: "Sample Message is required",
                      minLength: {
                        value: 20,
                        message: "Sample Message must be at least 20 characters",
                      },
                    }}
                    render={({ field: textField }) => (
                      <div>
                        <textarea
                          className="message-textarea"
                          placeholder="Write your sample message"
                          rows={4}
                          maxLength={1024 - ((`Reply STOP to opt-out of receiving messages from ${getValues("campaign_details.brand_name") && getValues("campaign_details.brand_name") !== "[CustomerName]"
                    ? getValues("campaign_details.brand_name") + '.'
                    : ""
                    }`).length + 2)}
                          {...textField}
                        />
                        <div className="d-flex justify-content-between mt-2 small text-muted">
                          <span>
                            Minimum 20 characters{" "}
                            {length < 20 ? `(need ${20 - length} more)` : "✓"}
                          </span>
                          <span>{length} characters</span>
                        </div>
                      </div>
                    )}
                  />
                  {errors?.campaign_details?.camp_desc?.smpl_msgs?.[index]
                    ?.msg_txt && (
                      <div className="text-danger mt-1 text-end">
                        {
                          errors.campaign_details.camp_desc.smpl_msgs[index]
                            .msg_txt.message
                        }
                      </div>
                    )}
                </div>
              </div>
            </div>
          );
        })}

        {/* Validation for minimum 2 sample messages */}
        <Controller
          name="campaign_details.camp_desc.smpl_msgs"
          control={control}
          rules={{
            validate: (value) => {
              if (!Array.isArray(value) || value.length < 2) {
                return "At least 2 sample messages are required";
              }
              return true;
            },
          }}
          render={() => null}
        />
        {errors?.campaign_details?.camp_desc?.smpl_msgs?.root && (
          <div className="text-danger mt-1 ms-3">
            {errors.campaign_details.camp_desc.smpl_msgs.root.message}
          </div>
        )}
        <div className="add-numbermain w-100 mt-3">
          <div className="camp-form p-0 w-100">
            <div className="p-3 rounded-3 bg-light border border-secondary">
              <div className="d-flex flex-column">
                <div className="tel-numbers fw-500 mb-2">
                  {`Reply STOP to opt-out of receiving messages from ${getValues("campaign_details.brand_name") && getValues("campaign_details.brand_name") !== "[CustomerName]"
                    ? getValues("campaign_details.brand_name") + '.'
                    : ""
                    }`}
                </div>
                <p className="phrecording text-secondary mb-0">
                  <strong>Note: </strong>
                  The above text will be appended with the Sample Message
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Obtaining Consent to Messaging — single text area (array-based dropdown removed) */}
        <div className="add-numbermain align-items-start noHoverBg">
          <div className="tel-numbers fw-500">
            Call to Action / Obtaining Consent  <span className="text-danger">*</span>
          </div>
        </div>

        <div className="camp-form p-0">
          <div className="p-3 rounded-3 mt-2 bg-opacity-10 add-numbermain w-100">
            <div className="message-section show w-100">
              <label className="tel-numbers fw-500">
               Call to Action / Obtaining Consent Message (Minimum 40 Characters): <span className="text-danger">*</span>
              </label>
              <Controller
                name="campaign_details.camp_desc.consent_msg"
                control={control}
                rules={{
                  required: " Call to Action / Obtaining Consent Message is required",
                  minLength: {
                    value: 40,
                    message: "Call to Action / Obtaining Consent Message must be at least 40 characters",
                  },
                }}
                render={({ field }) => {
                  const safeValue = typeof field.value === "string" ? field.value : "";
                  const length = safeValue.trim().length;
                  return (
                    <>
                      <textarea
                        className="message-textarea"
                        placeholder="Describe how consent is obtained, including opt-out instructions."
                        rows={4}
                        maxLength={2048}
                        value={safeValue}
                        onChange={(e) => field.onChange(e.target.value)}
                        onBlur={field.onBlur}
                        name={field.name}
                        ref={field.ref}
                      />
                      <div className="d-flex justify-content-between mt-2 small text-muted">
                        <span>
                          Minimum 40 characters{" "}
                          {length < 40 ? `(need ${40 - length} more)` : "✓"}
                        </span>
                        <span>{length} characters</span>
                      </div>
                    </>
                  );
                }}
              />
              {errors?.campaign_details?.camp_desc?.consent_msg && (
                <div className="text-danger mt-1">
                  {errors.campaign_details.camp_desc.consent_msg.message}
                </div>
              )}
            </div>
          </div>
        </div>

        

        {/* Does your website collect Phone numbers? */}
        <div className="add-numbermain w-100 mt-3">
          <div className="camp-form p-0 w-100">
            <div className="p-3 rounded-3 bg-light border border-secondary">
              <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
                <div>
                  <div className="tel-numbers fw-500 mb-2">
                    Does your website collect Phone numbers?
                  </div>
                  {/* <p className="phrecording text-secondary small mb-2">
                    Message & data rates may apply. Reply STOP to opt-out of further messaging. Reply HELP for more information.
                  </p> */}
                  <p className="phrecording text-muted mb-2">
                    {watch("campaign_details.camp_desc.msg_flow_chk") 
                      ? staticTexts?.msg_flow_chck_yes 
                      : staticTexts?.msg_flow_chck_no}
                  </p>
                  <p className="phrecording text-muted  mb-0">
                    <strong>Note: </strong>
                    The above text will be appended with the  Call to Action / Obtaining Consent Message
                  </p>
                </div>
                <div className="w-30">
                  <label className="switch">
                    <input
                      className="form-control"
                      type="checkbox"
                      checked={Boolean(watch("campaign_details.camp_desc.msg_flow_chk"))}
                      onChange={(e) => {
                        setValue("campaign_details.camp_desc.msg_flow_chk", e.target.checked, { shouldDirty: true });
                        if (e.target.checked) {
                          setwebsitecollectModal(true);
                        }
                      }}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>



        <MDBModal open={websitecollectModal} onClose={() => setwebsitecollectModal(false)} tabIndex='-1'>
          <MDBModalDialog size='lg'>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Alert</MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <div>
                  <p className="pb-3">Please ensure that the following entire statement is in clear view on your website</p>
                  <h6 className="my-2 text-dark" style={{ fontSize: '15px' }}>SMS Disclaimer:</h6>
                  <p>By providing a telephone number and submitting the form you are consenting to be contacted by SMS text message (our message frequency varies greatly). Message & data rates may apply. Reply STOP to opt-out of all text messaging. Reply HELP for more information. See our Privacy Policy.</p>
                </div>
              </MDBModalBody>

              <MDBModalFooter>
                <MDBBtn onClick={() => setwebsitecollectModal(false)}>OK</MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>



        {/* Standard Description Fields */}
        <div className="camp-form p-0">
          <div className=" p-3 rounded-3 mt-4 bg-opacity-10 add-numbermain w-100">
            <div className="message-section show w-100">
              <div className="message-header">
                <div className="d-flex align-items-center gap-2">
                  <label className="tel-numbers">
                    Campaign Description (Minimum 40 Characters): <span className="text-danger">*</span>
                  </label>
                </div>
              </div>

              <Controller
                name="campaign_details.camp_desc.desc"
                control={control}
                rules={{
                  required: "Campaign Description is required",
                  minLength: {
                    value: 40,
                    message: "Campaign Description must be at least 40 characters",
                  },
                }}
                render={({ field }) => (
                  <div>
                    <textarea
                      className="message-textarea"
                      placeholder="Describe the campaign description"
                      rows={4}
                      maxLength={4096}
                      {...field}
                    />
                    <div className="d-flex justify-content-between mt-2 small text-muted">
                      <span>
                        Minimum 40 characters{" "}
                        {field.value && field.value.length < 40
                          ? `(need ${40 - field.value.length} more)`
                          : "✓"}
                      </span>
                      <span>{field.value ? field.value.length : 0} characters</span>
                    </div>
                  </div>
                )}
              />
              {errors?.campaign_details?.camp_desc?.desc && (
                <div className="text-danger mt-1 text-end">
                  {errors.campaign_details.camp_desc.desc.message}
                </div>
              )}
            </div>
          </div>
          <div className=" p-3 rounded-3 mt-4 bg-opacity-10 add-numbermain w-100 ">
            <div className="message-section show w-100">
              <div className="message-header">
                <div className="d-flex align-items-center gap-2">
                  <label className="tel-numbers">
                    Opt-In Process Description:
                  </label>
                </div>
              </div>

              <Controller
                name="campaign_details.camp_desc.optin_desc"
                control={control}
                rules={{
                  required: "Opt-In Process Description is required",
                  minLength: {
                    value: 20,
                    message: "Opt-In Process Description must be at least 20 characters",
                  },
                }}
                render={({ field }) => (
                  <div>
                    <textarea
                      disabled={true}
                      className="message-textarea"
                      placeholder="Describe the opt-in process"
                      rows={4}
                      maxLength={1024}
                      {...field}
                    />
                    {/* <div className="d-flex justify-content-between mt-2 small text-muted">
                      <span>
                        Minimum 20 characters{" "}
                        {field.value && field.value.length < 20
                          ? `(need ${20 - field.value.length} more)`
                          : "✓"}
                      </span>
                      <span>{field.value ? field.value.length : 0} chars</span>
                    </div> */}
                  </div>
                )}
              />
              {errors?.campaign_details?.camp_desc?.optin_desc && (
                <div className="text-danger mt-1">
                  {errors.campaign_details.camp_desc.optin_desc.message}
                </div>
              )}
            </div>
          </div>

          <div className=" p-3 rounded-3 mt-4 bg-opacity-10 add-numbermain w-100 ">
            <div className="message-section show w-100">
              <div className="message-header">
                <div className="d-flex align-items-center gap-2">
                  <label className="tel-numbers">
                    Opt-Out Process Description:
                  </label>
                </div>
              </div>

              <Controller
                name="campaign_details.camp_desc.optout_desc"
                control={control}
                rules={{
                  required: "Opt-Out Process Description is required",
                  minLength: {
                    value: 20,
                    message: "Opt-Out Process Description must be at least 20 characters",
                  },
                }}
                render={({ field }) => (
                  <div>
                    <textarea
                      className="message-textarea"
                      placeholder="Describe the opt-out process"
                      disabled={true}
                      rows={4}
                      maxLength={1024}
                      {...field}
                    />
                    {/* <div className="d-flex justify-content-between mt-2 small text-muted">
                      <span>
                        Minimum 20 characters{" "}
                        {field.value && field.value.length < 20
                          ? `(need ${20 - field.value.length} more)`
                          : "✓"}
                      </span>
                      <span>{field.value ? field.value.length : 0} chars</span>
                    </div> */}
                  </div>
                )}
              />
              {errors?.campaign_details?.camp_desc?.optout_desc && (
                <div className="text-danger mt-1">
                  {errors.campaign_details.camp_desc.optout_desc.message}
                </div>
              )}
            </div>
          </div>

          <div className=" p-3 rounded-3 mt-4 bg-opacity-10 add-numbermain w-100 ">
            <div className="message-section show w-100">
              <div className="message-header">
                <div className="d-flex align-items-center gap-2">
                  <label className="tel-numbers">
                    Help Process Description:
                  </label>
                </div>
              </div>

              <Controller
                name="campaign_details.camp_desc.help_desc"
                control={control}
                rules={{
                  required: "Help Process Description is required",
                  minLength: {
                    value: 20,
                    message: "Help Process Description must be at least 20 characters",
                  },
                }}
                render={({ field }) => (
                  <div>
                    <textarea
                      className="message-textarea"
                      placeholder="Describe the help process"
                      rows={4}
                      maxLength={1024}
                      disabled={true}
                      {...field}
                    />
                    {/* <div className="d-flex justify-content-between mt-2 small text-muted">
                      <span>
                        Minimum 20 characters{" "}
                        {field.value && field.value.length < 20
                          ? `(need ${20 - field.value.length} more)`
                          : "✓"}
                      </span>
                      <span>{field.value ? field.value.length : 0} chars</span>
                    </div> */}
                  </div>
                )}
              />
              {errors?.campaign_details?.camp_desc?.help_desc && (
                <div className="text-danger mt-1">
                  {errors.campaign_details.camp_desc.help_desc.message}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CampaignTypes;